module.exports = __webpack_public_path__ + "img/Phone1.3c3745ee.png";